import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'checkbox',
  props: {
    name: null,
    value: { type: [Boolean, Array] },
    color: null,
    width: null,
    height: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name: string;
  value: boolean | [];
  color?: string;
  width?: string | number;
  height?: string | number;
  disabled?: boolean;
};

const IconCheck = defineAsyncComponent(() => import('@white-label-icon/icon-check'));





function onChange() {
  emit('input', !props.value);
}

return { __sfc: true,IconCheck, props, emit, onChange }
}

})